import React from 'react';
import { SummaryList } from '../SummaryList';
import { getSelectedWorkshops } from '../../Util';
import { localize } from '../../Util/L10n';

export const Summary = function ({ value, workshops, onCloseOverlayClick }) {
  const selectedWorkshops = getSelectedWorkshops(value, workshops);

  let count = selectedWorkshops.length;
  let countWorkshopLabel = `${localize(
    count > 1 || count === 0 ? 'signedUpForWorkshops' : 'signedUpForWorkshop'
  )}`;

  return (
    <React.Fragment>
      <SummaryList selectedWorkshops={selectedWorkshops} />
      <div className="WorkshopsSummary__Footer">
        <div className="WorkshopsSummary__FooterLeft">
          {localize('signedUpFor')}{' '}
          <strong>
            {count} {countWorkshopLabel}
          </strong>
        </div>
        <div className="WorkshopsSummary__FooterRight">
          <button
            type="button"
            onClick={onCloseOverlayClick}
            className="WorkshopsSummary__Button"
          >
            {localize('applySelectionAction')}
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};
